module.exports = __webpack_public_path__ + "img/pdf.feda7f26.jpg";